<template>
	<div>
		<div hidden v-if="roleName === 'SYSTEM_ADMIN' || roleName === 'SYSTEM_USER' || roleName === 'ORGANIZATION_ADMIN'">
			<DeleteDialog :dialog.sync="showDeleteDialog" @confirm="showDeleteDialog = false;deleteUserConfirm();" />
		</div>
		<v-data-table
			v-if="filteredHospitalAdmins"
			class="medical-staff-data-table"
			:loading="loading"
			:headers="headers"
			:headers-length="headers.length"
			:search="appBarSearch"
			:no-data-text="$t('no-data-available')"
			:loading-text="$t('loading')"
			:items="filteredHospitalAdmins"
			sort-by="id"
			item-key="id"
			fixed-header
			dense
			@click:row="selectedHospitalAdminRow"
			:height="pageHeight(174)"
			:items-per-page="-1"
			:footer-props="getDataTableFooterProps('adminsTable')">
			<template v-slot:item="{ item, index }">
				<tr :class="getRowsForDataTable(index)" @click="selectedHospitalAdminRow(item)">
					<td class="text-left font-size12-5 font-weight-medium">
						<v-icon small :style="item.status === 1 ? 'color: #09CB09' : ''">mdi-checkbox-blank-circle</v-icon>
						{{ item.firstName }} {{ item.lastName }}
					</td>
					<td class="text-left font-size12-5 font-weight-medium">
						<div class="d-flex">
							<v-img :src="doctorBlack" class="mr-2" max-width="13px" max-height="20px" />
							{{ item?.roleData?.roleNameForDisplay }}
						</div>
					</td>
					<td class="text-left font-size12-5 font-weight-medium">
						<img :src="item?.hospitalAssignedData === null ? '' : HospitalBlack" height="17" />
						{{ item?.hospitalAssignedData === null ? '' : item?.hospitalAssignedData?.hospitalName }}
					</td>
					<td class="text-left font-size12-5 font-weight-medium">
						<v-icon small color="primary">mdi-email</v-icon>
						{{ item.email }}
					</td>
					<td class="text-left font-size12-5 font-weight-medium">
						<v-icon color="primary" small>mdi-phone</v-icon>
						{{ item.phone }}
					</td>
					<td>
						<div class="d-flex align-center justify-end">
							<v-menu left bottom class="py-0" offset-y transition="slide-x-transition">
								<template v-slot:activator="{ on, attrs }">
									<v-btn icon color="black" v-bind="attrs" v-on="on">
										<span class="mdi mdi-18px mdi-dots-horizontal"></span>
									</v-btn>
								</template>

								<v-list class="px-0" dense>
									<v-list-item class="py-0 my-0" link dense @click="handleActionView(item)">
										<v-list-item-icon class="mx-1">
											<v-icon class="icon-img mdi-18px" color="black">mdi-eye</v-icon>
										</v-list-item-icon>
										<v-list-item-content class="font-bold font-size14">{{ $t('view') }}</v-list-item-content>
									</v-list-item>
									<v-list-item link dense @click="handleToggleStatus(item)">
										<v-list-item-icon class="mx-1">
											<v-icon class="icon-img mdi-18px" color="black">mdi-refresh</v-icon>
										</v-list-item-icon>
										<v-list-item-content class="font-bold font-size14"
											>{{ $t('change') }} {{ $t('status') }}</v-list-item-content
										>
									</v-list-item>
									<v-list-item link dense @click="handleActionSendEmail(item)">
										<v-list-item-icon class="mx-1">
											<v-icon class="icon-img mdi-18px" color="black">mdi-lock-reset</v-icon>
										</v-list-item-icon>
										<v-list-item-content
											class="font-bold font-size14"
											v-if="item.status !== 1"
											label
											@click.stop="sendActivationEmail(item, 'USER_CONFIRMATION')"
											>{{ $t('send-activation-email') }}</v-list-item-content
										>
										<v-list-item-content
											class="font-bold font-size14 text-left"
											v-else
											label
											@click.stop="sendActivationEmail(item, 'RESET_PASSWORD')"
											>{{ $t('send-reset-password-email') }}</v-list-item-content
										>
									</v-list-item>
									<v-divider />
									<v-list-item
										v-if="
											roleName === 'SYSTEM_ADMIN' || roleName === 'SYSTEM_USER' || roleName === 'ORGANIZATION_ADMIN'
										"
										link
										dense
										@click="handleActionDelete(item)">
										<v-list-item-icon class="mx-1">
											<v-icon color="red">mdi-trash-can-outline</v-icon>
										</v-list-item-icon>
										<v-list-item-content class="font-bold font-size14">{{ $t('delete') }}</v-list-item-content>
									</v-list-item>
								</v-list>
							</v-menu>
						</div>
					</td>
				</tr>
			</template>
			<template v-slot:footer.prepend>
				<span class="font-weight-bold mx-3">{{ $t('table-legend') }}:</span>
				<v-tooltip color="green" top>
					<template v-slot:activator="{ on }">
						<div class="d-flex">
							<span class="font-weight-medium font-size12-5">{{ $t('active') }}</span>
							<v-icon class="mdi-18px color-green px-2" v-on="on">mdi-checkbox-blank-circle</v-icon>
						</div>
					</template>
					<span>{{ $t('active') }}</span>
				</v-tooltip>
				<v-tooltip color="gray" top>
					<template v-slot:activator="{ on }">
						<div class="d-flex">
							<span class="font-weight-medium font-size12-5">{{ $t('inactive') }} / {{ $t('pending') }}</span>
							<v-icon class="mdi-18px color-gray px-2" v-on="on">mdi-checkbox-blank-circle</v-icon>
						</div>
					</template>
					<span class="text--primary">{{ $t('inactive') }} / {{ $t('pending') }}</span>
				</v-tooltip>
			</template>
		</v-data-table>
	</div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import { showSuccessAlert, showErrorAlert, getDataTableFooterProps, getRowsForDataTable } from '@/utils/utilities';
import Offices from '@/views/Admin/Offices.vue';
import { doctorBlack, hospitalBlack } from '@/assets';
import DeleteDialog from '@/views/dialogs/DeleteDialog.vue';

export default {
	components: { DeleteDialog },
	data () {
		return {
			loading: true,
			headerClass: 'color-header',
			selectedItem: {},
			HospitalBlack: hospitalBlack,
			showDeleteDialog: false,
		};
	},
	computed: {
		doctorBlack () {
			return doctorBlack;
		},
		Offices () {
			return Offices;
		},
		...mapGetters({
			roleName: 'authentication/getRole',
			pageHeight: 'pageHeight',
			appBarSearch: 'filterbar/getSearch',
			appBarMedicalInstitution: 'filterbar/getMedicalInstitution',
			appBarUserStatusVerifier: 'filterbar/getUserStatusVerifier',
			appBarRole: 'filterbar/getRole',
		}),
		...mapState({
			organizationAdmins: (state) => state.users.organizationAdmins,
			hospitalAdminUsers: (state) => state.users.hospitalAdmins,
			caregivers: (state) => state.users.caregivers,
			allVerifiers: (state) => state.verifiers.allverifires,
			allRoles: (state) => state.roles.roles,
			authenticated: (state) => state.authentication.userData,
			partners: (state) => state.users.partners,
			apiUsers: (state) => state.users.apiUsers,
		}),
		headers () {
			var headers = [];
			headers = [
				{
					text: this.$t('name'),
					value: 'firstName',
					class: this.headerClass,
				},
				{
					text: this.$t('role'),
					value: 'hospitalAssignedData?.roleNameForDisplay',
					class: this.headerClass,
				},
				{
					text: this.$t('location'),
					value: 'hospitalAssignedData?.hospitalName',
					class: this.headerClass,
				},

				{
					text: this.$t('email'),
					value: 'email',
					class: this.headerClass,
				},
				{
					text: this.$t('phone'),
					value: 'phone',
					class: this.headerClass,
				},
				{
					text: '',
					value: '',
					class: this.headerClass,
					sortable: false,
				},
			];
			return headers;
		},
		filteredHospitalAdmins () {
			let calculateFileteredHospitalAdmins = [];
			if (this.organizationAdmins) {
				this.organizationAdmins.forEach((element) => {
					calculateFileteredHospitalAdmins.push(element);
				});
			}

			if (this.hospitalAdminUsers) {
				this.hospitalAdminUsers.forEach((element) => {
					calculateFileteredHospitalAdmins.push(element);
				});
			}
			if (this.partners) {
				this.partners.forEach((element) => {
					calculateFileteredHospitalAdmins.push(element);
				});
			}
			if (this.apiUsers) {
				this.apiUsers.forEach((element) => {
					calculateFileteredHospitalAdmins.push(element);
				});
			}

			if (this.caregivers) {
				this.caregivers.forEach((element) => {
					calculateFileteredHospitalAdmins.push(element);
				});
			}

			if (this.appBarMedicalInstitution !== 0 && this.appBarMedicalInstitution !== null) {
				// filter by medicalInstitutionId
				calculateFileteredHospitalAdmins = calculateFileteredHospitalAdmins.filter(
					(u) => u.organizationId === this.appBarMedicalInstitution,
				);
			}

			if (this.appBarUserStatusVerifier !== -99 && this.appBarUserStatusVerifier !== null) {
				// filter by userStatusId
				calculateFileteredHospitalAdmins = calculateFileteredHospitalAdmins.filter(
					(u) => u.status === this.appBarUserStatusVerifier,
				);
			}

			if (this.appBarRole !== -99 && this.appBarRole !== null) {
				// filter by userStatusId
				calculateFileteredHospitalAdmins = calculateFileteredHospitalAdmins.filter((u) => u.roleId === this.appBarRole);
			}
			return calculateFileteredHospitalAdmins;
		},
	},
	async mounted () {
		await this.getOrganizationAmdinUsers();
		await this.getHospitalAmdinsUsers();
		// await this.getCaregivers();
		await this.getAllVerifiers();
		await this.getAllRoles();
		await this.$store.dispatch('filterbar/AppBarUserStatusVerifier', -99);
		await this.getPartners();
		await this.getApiUsers();
	},
	methods: {
		getRowsForDataTable,
		getDataTableFooterProps,
		async getPartners () {
			const organizationId = this.roleName === 'SYSTEM_ADMIN' ? -1 : this.authenticated.organizationId;
			const body = {
				organizationId: organizationId,
			};

			await this.$store.dispatch('users/getPartners', body);
		},
		async getApiUsers () {
			if (this.roleName === 'SYSTEM_ADMIN') {
				this.loading = true;
				await this.$store.dispatch('users/getApiUsers').then(() => {
					this.loading = false;
				});
			}
		},
		async getOrganizationAmdinUsers () {
			this.loading = true;
			await this.$store.dispatch('users/getOrganizationAdmins').then(() => {
				this.loading = false;
			});
		},
		async getHospitalAmdinsUsers () {
			this.loading = true;
			await this.$store.dispatch('users/getHospitalAdmins').then(() => {
				this.loading = false;
			});
		},
		async getCaregivers () {
			await this.$store.dispatch('users/getCaregivers').then(() => {
				this.loading = false;
			});
		},
		async getAllVerifiers () {
			// we call this API endpoint only if the store values are null
			if (this.allVerifiers == null) {
				await this.$store.dispatch('verifiers/getAllVerifiers').then(() => {
					// this.loading = false;
				});
			}
		},
		async getAllRoles () {
			// we call this API endpoint only if the store values are null
			if (this.allRoles == null) {
				await this.$store.dispatch('roles/getRoles').then(() => {
					// this.loading = false;
				});
			}
		},
		async editHospitalAdmin (item) {
			// await this.$store.commit('users/SELECTED_HOSPITAL_ADMIN', item); // get from the store, not from API call
			if (item.roleData.roleName === 'HOSPITAL_ADMIN') {
				this.$store.commit('users/SELECTED_ORGANIZATION_ADMIN'); // set selectedHospitalAdmin = null
				this.$store.commit('users/SELECTED_CARE_GIVER'); // set selectedCaregiver = null
				this.$store.commit('users/SELECTED_PARTNER'); // set selectedCaregiver = null
				await this.$store.commit('users/SELECTED_API_USER');
				await this.$store.commit('users/SELECTED_HOSPITAL_ADMIN', item); // get from the store, not from API call
			} else if (item.roleData.roleName === 'ORGANIZATION_ADMIN') {
				this.$store.commit('users/SELECTED_HOSPITAL_ADMIN'); // set selectedHospitalAdmin = null
				this.$store.commit('users/SELECTED_CARE_GIVER'); // set selectedCaregiver = null
				this.$store.commit('users/SELECTED_PARTNER'); // set selectedCaregiver = null
				await this.$store.commit('users/SELECTED_API_USER');
				await this.$store.commit('users/SELECTED_ORGANIZATION_ADMIN', item); // get from the store, not from API call
			} else if (item.roleData.roleName === 'CARE_GIVER') {
				this.$store.commit('users/SELECTED_ORGANIZATION_ADMIN'); // set selectedHospitalAdmin = null
				this.$store.commit('users/SELECTED_HOSPITAL_ADMIN'); // set selectedHospitalAdmin = null
				this.$store.commit('users/SELECTED_PARTNER'); // set selectedCaregiver = null
				await this.$store.commit('users/SELECTED_API_USER');
				await this.$store.commit('users/SELECTED_CARE_GIVER', item); // get from the store, not from API call
			} else if (item.roleData.roleName === 'PARTNER') {
				this.$store.commit('users/SELECTED_ORGANIZATION_ADMIN'); // set selectedHospitalAdmin = null
				this.$store.commit('users/SELECTED_HOSPITAL_ADMIN'); // set selectedHospitalAdmin = null
				this.$store.commit('users/SELECTED_CARE_GIVER');
				await this.$store.commit('users/SELECTED_API_USER');

				await this.$store.commit('users/SELECTED_PARTNER', item); // get from the store, not from API call
			} else if (item.roleData.roleName === 'API_USER') {
				this.$store.commit('users/SELECTED_ORGANIZATION_ADMIN'); // set selectedHospitalAdmin = null
				this.$store.commit('users/SELECTED_HOSPITAL_ADMIN'); // set selectedHospitalAdmin = null
				this.$store.commit('users/SELECTED_PARTNER'); // set partners = null
				this.$store.commit('users/SELECTED_CARE_GIVER'); // set caregiver = null

				await this.$store.commit('users/SELECTED_API_USER', item); // get from the store, not from API call
			}

			// else if(item.roleDat)

			this.$store.commit('SET_EDIT_DETAILS_DRAWER', true);
		},
		selectedHospitalAdminRow (item) {
			this.editHospitalAdmin(item);
		},
		async sendActivationEmail (item, validationType) {
			if (validationType === null || validationType === undefined) {
				validationType = 'RESET_PASSWORD';
			}
			const sendValidationEmail = { email: item.email, validationType: validationType };
			await this.$store.dispatch('users/sendValidationLinkByEmail', sendValidationEmail).then((res) => {
				if (res.resFlag) {
					showSuccessAlert(this.$t('success-operation'));
				} else {
					showErrorAlert(this.$t('failed-operation'));
				}
			});
		},
		handleActionView (item) {
			this.editHospitalAdmin(item);
		},
		async handleToggleStatus (item) {
			if (item.status === -1) {
				// not validated user
				// showErrorAlert(this.$t('failed-operation'));
				showErrorAlert(this.$t('not-activated-user'));
				return;
			}

			const params = { userId: item.id, statusValueToSet: item.status === 1 ? 0 : 1 };
			await this.$store.dispatch('users/setUserStatus', params).then((res) => {
				if (res.resFlag) {
					showSuccessAlert(this.$t('success-operation'));

					if (item.roleId === 6) {
						this.getHospitalAmdinsUsers(); // reload the list of hospital admins
					} else if (item.roleId === 8) {
						this.getOrganizationAmdinUsers(); // reload the list of organization admins
					} else if (item.roleId === 7) {
						this.getCaregivers(); // reload the list of caregivers
					} else if (item.roleId === 10) {
						this.getApiUsers(); // reload the list of caregivers
					}
				} else {
					showErrorAlert(this.$t('failed-operation'));
				}
			});
		},
		handleActionSendEmail (item) {
			this.sendActivationEmail(item);
		},
		async handleActionDelete (item) {
			this.showDeleteDialog = true;
			this.selectedItem = item;
		},
		async deleteUserConfirm () {
			await this.$store.dispatch('users/deleteUser2', this.selectedItem).then((res) => {
				if (res.resFlag) {
					showSuccessAlert(this.$t('success-operation'));

					if (this.selectedItem.roleId === 6) {
						this.getHospitalAmdinsUsers(); // reload the list of hospital admins
					} else if (this.selectedItem.roleId === 8) {
						this.getOrganizationAmdinUsers(); // reload the list of organization admins
					} else if (this.selectedItem.roleId === 7) {
						this.getCaregivers(); // reload the list of caregivers
					} else if (this.selectedItem.roleId === 9) {
						this.getPartners(); // reload the list of partners
					} else if (this.selectedItem.roleId === 10) {
						this.getApiUsers(); // reload the list of partners
					}
					this.closeDeleteDialog();
				} else {
					showErrorAlert(this.$t('failed-operation'));
				}
			});
		},
		closeDeleteDialog () {
			this.showDeleteDialog = false;
			this.selectedItem = {};
		},
	},
	beforeDestroy () {
		this.$store.commit('SET_EDIT_DETAILS_DRAWER', false);
	},
};
</script>
